const ITEM_SELECTOR = '.umb-block-grid__layout-item';
const IN_VIEW_CLASS = 'umb-block-grid__layout-item--in-view';
const THRESHOLD = 0.33;

/**
 * Assigns IN_VIEW_CLASS to items matching ITEM_SELECTOR when (THRESHOLD * 100)% of the element is visible in the viewport
 */
function initInViewObserver(): void {
    const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
            const element = entry.target as HTMLElement;
            if (entry.intersectionRatio >= THRESHOLD) {
                element.classList.add(IN_VIEW_CLASS);
                // observe only once, if you need repeated animations remove this line
                observer.unobserve(element);
            }
        }
    }, { root: null, threshold: THRESHOLD });

    // Observe current items
    document.querySelectorAll<HTMLElement>(ITEM_SELECTOR).forEach((element) => observer.observe(element));

    // Observe future items (e.g. CMS-rendered later)
    const mutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of Array.from(mutation.addedNodes)) {
                if (node instanceof HTMLElement) {
                    if (node.matches(ITEM_SELECTOR)) {
                        observer.observe(node);
                    } else {
                        node.querySelectorAll<HTMLElement>(ITEM_SELECTOR).forEach((el) => observer.observe(el));
                    }
                }
            }
        }
    });

    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInViewObserver, { once: true });
} else {
    initInViewObserver();
}

export { };
